<template>
  <page-header-wrapper>
    <div class="finance-flow-page erp-list-page baidao-list-page">
      <div class="erp-search-card">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="5" :sm="24">
              <a-form-item label="支付流水编号">
                <a-input v-model.trim="query.paymentFlowNo" allow-clear placeholder="请输入" @pressEnter="search" />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="销售订单编号">
                <a-input v-model.trim="query.salesOrderNo" allow-clear placeholder="请输入" @pressEnter="search" />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="流水号">
                <a-input v-model.trim="query.transactionNo" allow-clear placeholder="请输入" @pressEnter="search" />
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <a-form-item label="流水类型">
                <a-select v-model="query.flowType" allow-clear placeholder="全部">
                  <a-select-option v-for="item in flowTypeOptions" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="支付方式">
                <a-select v-model="query.payMethod" allow-clear placeholder="全部">
                  <a-select-option v-for="item in payMethodOptions" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24" class="erp-search-actions">
              <a-button type="primary" icon="search" @click="search">搜索</a-button>
              <a-button icon="redo" @click="reset">重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="erp-table-card">
        <div class="erp-table-toolbar">
          <div>
            <h3>支付流水</h3>
            <p>查看销售订单对应的支付与退款流水。</p>
          </div>
          <div class="erp-toolbar-actions">
            <a-button icon="download" :loading="exporting" @click="exportRows">导出</a-button>
          </div>
        </div>
        <a-table
          :row-key="rowKey"
          :columns="columns"
          :data-source="rows"
          :loading="loading"
          :pagination="pagination"
          :row-selection="{ selectedRowKeys, onChange: keys => { selectedRowKeys = keys } }"
          bordered
          size="middle"
          :scroll="{ x: 1280 }"
          @change="onPageChange">
          <template slot="index" slot-scope="text, record, index">{{ rowIndex(index) }}</template>
          <template slot="amount" slot-scope="value"><span class="erp-money">¥{{ money(value) }}</span></template>
          <template slot="emptyValue" slot-scope="value">{{ displayValue(value) }}</template>
          <template slot="voucher" slot-scope="value">
            <a v-if="voucherUrl(value)" :href="voucherUrl(value)" target="_blank">查看</a>
            <span v-else>—</span>
          </template>
        </a-table>
      </div>
    </div>
  </page-header-wrapper>
</template>

<script>
import { getDicts } from '@/api/system/dict/data'
import { pagePaymentFlow } from '@/api/erp/finance'

const blankQuery = () => ({
  paymentFlowNo: '',
  salesOrderNo: '',
  transactionNo: '',
  flowType: undefined,
  payMethod: undefined
})

export default {
  name: 'ErpFinancePaymentFlow',
  data () {
    return {
      loading: false,
      exporting: false,
      rows: [],
      selectedRowKeys: [],
      query: blankQuery(),
      pagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true, showQuickJumper: true },
      flowTypeOptions: [
        { value: 'pay', label: '支付' },
        { value: 'refund', label: '退款' }
      ],
      payMethodOptions: [
        { value: 'bank_transfer', label: '银行转账' },
        { value: 'wechat', label: '微信支付' },
        { value: 'alipay', label: '支付宝' },
        { value: 'cash', label: '现金' }
      ],
      columns: [
        { title: '序号', dataIndex: 'index', width: 70, align: 'center', scopedSlots: { customRender: 'index' } },
        { title: '支付流水编号', dataIndex: 'paymentFlowNo', width: 200, scopedSlots: { customRender: 'emptyValue' } },
        { title: '销售订单编号', dataIndex: 'salesOrderNo', width: 200, scopedSlots: { customRender: 'emptyValue' } },
        { title: '流水金额', dataIndex: 'amount', width: 130, align: 'right', scopedSlots: { customRender: 'amount' } },
        { title: '流水号', dataIndex: 'transactionNo', width: 180, scopedSlots: { customRender: 'emptyValue' } },
        { title: '流水类型', dataIndex: 'flowTypeName', width: 110, scopedSlots: { customRender: 'emptyValue' } },
        { title: '支付方式', dataIndex: 'payMethodName', width: 130, scopedSlots: { customRender: 'emptyValue' } },
        { title: '支付时间', dataIndex: 'payTime', width: 180, scopedSlots: { customRender: 'emptyValue' } },
        { title: '支付凭证', dataIndex: 'voucherUrl', width: 110, scopedSlots: { customRender: 'voucher' } }
      ]
    }
  },
  created () {
    this.loadDicts()
    this.load()
  },
  methods: {
    rowKey (record) { return String(record.id) },
    displayValue (value) { return value === null || value === undefined || value === '' ? '—' : value },
    money (value) { return Number(value || 0).toFixed(2) },
    rowIndex (index) { return (this.pagination.current - 1) * this.pagination.pageSize + index + 1 },
    voucherUrl (value) {
      const text = String(value || '').trim()
      return text && /^https?:\/\//i.test(text.split(',')[0]) ? text.split(',')[0] : ''
    },
    buildQuery (pageNum, pageSize) {
      return {
        ...this.query,
        pageNum: pageNum || this.pagination.current,
        pageSize: pageSize || this.pagination.pageSize
      }
    },
    load () {
      this.loading = true
      pagePaymentFlow(this.buildQuery()).then(res => {
        const data = res.data || {}
        this.rows = data.records || []
        this.pagination.total = Number(data.total || 0)
      }).finally(() => { this.loading = false })
    },
    search () { this.pagination.current = 1; this.selectedRowKeys = []; this.load() },
    reset () { this.query = blankQuery(); this.search() },
    onPageChange (page) {
      this.pagination.current = page.current
      this.pagination.pageSize = page.pageSize
      this.load()
    },
    loadDicts () {
      const mapOptions = res => (res.data || []).map(item => ({ value: item.dictValue, label: item.dictLabel }))
      getDicts('finance_payment_flow_type').then(res => {
        const options = mapOptions(res)
        if (options.length) this.flowTypeOptions = options
      }).catch(() => {})
      getDicts('finance_payment_method').then(res => {
        const options = mapOptions(res).filter(item => item.value !== 'bank_refund')
        if (options.length) this.payMethodOptions = options
      }).catch(() => {})
    },
    exportRows () {
      this.exporting = true
      pagePaymentFlow(this.buildQuery(1, 5000)).then(res => {
        const records = (res.data && res.data.records) || []
        if (!records.length) {
          this.$message.warning('当前查询无可导出数据')
          return
        }
        const header = ['支付流水编号', '销售订单编号', '流水金额', '流水号', '流水类型', '支付方式', '支付时间', '支付凭证']
        const lines = [header.join(',')]
        records.forEach(row => {
          lines.push([
            row.paymentFlowNo,
            row.salesOrderNo,
            this.money(row.amount),
            row.transactionNo,
            row.flowTypeName || row.flowType,
            row.payMethodName || row.payMethod,
            row.payTime,
            row.voucherUrl
          ].map(value => `"${String(value == null ? '' : value).replace(/"/g, '""')}"`).join(','))
        })
        const blob = new Blob(['\ufeff' + lines.join('\n')], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = '支付流水.csv'
        link.click()
        URL.revokeObjectURL(url)
      }).finally(() => { this.exporting = false })
    }
  }
}
</script>
